import Input from './input';
// import Vue from 'Vue'
export default Vue => {
  Vue.component(Input.name, Input);
};
